import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SubContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.green2};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.large};
  }
`

export const SubTitle = styled.span`
  font-size: ${theme.font.sizes.xsmall};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray500};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.small};
  }
`

export const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;

  font-size: ${theme.font.sizes.xsmall};
  color: ${theme.colors.system};

  background: transparent;

  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${theme.colors.system};
    }
  }

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.small};
  }
`

export const CancelButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;

  font-size: ${theme.font.sizes.xsmall};
  color: ${theme.colors.erro};

  background: transparent;

  cursor: pointer;

  svg {
    width: 10px;
    height: 10px;

    path {
      fill: ${theme.colors.erro};
    }
  }

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.small};
  }
`

export const Content = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 8px;

  color: ${theme.colors.gray900};
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
    gap: 16px;
  }
`
